import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/Auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import ProtocolDetail from "@/pages/ProtocolDetail";
import ProtocolEditor from "@/pages/ProtocolEditor";
import { InterventionList, InterventionEditor } from "@/pages/Interventions";
import { IllustrationList, PoseEditor } from "@/pages/Illustrations";
import { ReviewQueue, Suggest, AuditLog, Pack, Verify } from "@/pages/Misc";
import BulkCreate from "@/pages/BulkCreate";
import Admin from "@/pages/Admin";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="p-8 text-sm text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/verify/:docId" element={<Verify />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/library" element={<Library />} />
            <Route path="/protocols/:pid" element={<ProtocolDetail />} />
            <Route path="/editor/:vid" element={<ProtocolEditor />} />
            <Route path="/interventions" element={<InterventionList />} />
            <Route path="/interventions/:iid" element={<InterventionEditor />} />
            <Route path="/illustrations" element={<IllustrationList />} />
            <Route path="/illustrations/:id" element={<PoseEditor />} />
            <Route path="/review" element={<ReviewQueue />} />
            <Route path="/suggest" element={<Suggest />} />
            <Route path="/bulk" element={<BulkCreate />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/pack" element={<Pack />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
